// Bootstrap styles
import '/@theme/assets/css/bootstrap.css'

// Load required icons
import { Iconloader } from '@vectioneer/ui'
new Iconloader().load()
